// this file was prevaled
/**
 * Build config: configuration set at build time.
 * @module soapbox/build-config
 */module.exports={"NODE_ENV":"production","BACKEND_URL":"https://headpat.cafe","FE_SUBDIRECTORY":"/","FE_BUILD_DIR":"static","FE_INSTANCE_SOURCE_DIR":"instance"};